import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { renderHTMLString } from '../../../helpers';
import { withBrand } from '../../../providers/BrandProvider';
import EmailOptInModule from '../../styled/siteBuilderModules/EmailOptInModule';
import './BookingClosedSection.scss';

export function BookingClosedSection(props) {
  const {
    siteProducts: { bookingClosedMessage: bookingClosedMessageEvent } = {},
    courseOptions: { bookingClosedMessage: bookingClosedMessageCourse } = {},
    pageConfig: { location } = {},
    brand: { secondaryColor } = {},
    t,
  } = props;

  const componentStyle = {
    backgroundColor: secondaryColor,
  };
  const bookingClosedMessage =
    bookingClosedMessageEvent || bookingClosedMessageCourse;

  return (
    <div className="c-booking-closed-section" style={componentStyle}>
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <h1 className="c-booking-closed-section__heading">
              {t('event.purchase.booking-closed')}
            </h1>
            {bookingClosedMessage && (
              <div className="c-booking-closed-section__message">
                {renderHTMLString(bookingClosedMessage, location)}
              </div>
            )}
            <EmailOptInModule
              section={{
                contentType: 'booking_closed',
                type: 'event_lead_generation_section',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

BookingClosedSection.propTypes = {
  siteProducts: PropTypes.shape({
    bookingClosedMessage: PropTypes.string,
  }),
  courseOptions: PropTypes.shape({
    bookingClosedMessage: PropTypes.string,
  }),
  brand: PropTypes.shape({
    secondaryColor: PropTypes.string,
  }),
};

function mapStateToProps(state) {
  return {
    siteProducts: state.siteProducts,
    courseOptions: state.courseOptions,
    pageConfig: state.pageConfig,
  };
}

export default withTranslation()(
  connect(mapStateToProps)(withBrand(BookingClosedSection)),
);
